import { useCallback } from 'react';
import { useDispatch } from '@bonanza-social/toolkit/state';
import { Box, Text, Button } from '@bonanza-social/moonlight';
import { Screen } from '@bonanza-social/navigation';
import { openChat } from '@bonanza-social/chat/state';
import OpenInboxButton from '../components/OpenInboxButton/OpenInboxButton';

function ForgotPasswordSubmittedScreen() {
  const dispatch = useDispatch();

  const onSubmitPress = useCallback(() => {
    dispatch(openChat());
  }, [dispatch]);

  return (
    <Screen paddingBottom="safe-area-inset-bottom">
      <Box flex={1} justifyContent="space-between">
        <Box gap="space-600">
          <Text
            variant="h4"
            gradient="darkSurfaceAccent"
            locNS="auth"
            locKey="forgotPasswordLinkSentTitle"
          />
          <Text
            variant="body-m"
            color="darkSurfacePrimary"
            locNS="auth"
            locKey="forgotPasswordLinkSentDescription"
          />
        </Box>
        <Box gap="space-600">
          <OpenInboxButton />
          <Button
            size="large"
            variant="secondary"
            locNS="auth"
            locKey="forgotPasswordContactSupport"
            onPress={onSubmitPress}
          />
        </Box>
      </Box>
    </Screen>
  );
}

export default ForgotPasswordSubmittedScreen;
